import React, { FC, useEffect, useState } from 'react'
import AuthorizedRouter from './authorized.router'
import NoAuthorizedRouter from './noAuthorized.router'
import {RouterWrapper} from './styles'
import { Routes, Route} from 'react-router-dom';
import TopProgress from '../components/TopBarProgress';
import { useAuth } from '../context/user.context';
import {AccessDenied, TechBreak} from '../pages'
import { usePermission } from '../permissions';
import { affiliateService, authService } from '../api';
import { useQueryParam, StringParam } from 'use-query-params';
import { useCookies } from 'react-cookie';
// import { useQueryParam, StringParam, NumberParam, ArrayParam } from 'use-query-params';

type RouterProps = {
  isAuth:boolean
}
  
          
const RootRouter:FC<RouterProps> = ({isAuth}) => {
  const {user, networkErr, setNetworkErr, techWork, setTechWork} = useAuth()
  const { snapshot } = usePermission()
  const permissionPending = Boolean(user?.user) && snapshot.status !== 'ready' && snapshot.status !== 'error'
  const permissionFailed = Boolean(user?.user) && snapshot.status === 'error'


  // useEffect(() => {
  //   if(cookies?.refCode && cookies?.refCode?.length > 0){
  //     // console.log('pidor', cookies);
  //     affiliateService.addToReff({link:`https://ocp-front-dev.netengi.com?ref=${cookies?.refCode}`})
  //   }
  // },[cookies])
  // useEffect(() => {
  //   if(ref && ref?.length > 0){
  //     affiliateService.addToReff({link:`https://ocp-front-dev.netengi.com?ref=${ref}`})
  //   }
  // },[ref])
  return(
      <RouterWrapper data-test-id='app-shell'>
        <TopProgress loading={permissionPending}/>
        <Routes>
          {/* {user !== null && user?.user !== undefined ?  */}
          {techWork ?
            <Route path='/*' element={<TechBreak/>}/>
          : permissionFailed ?
            <Route path='/*' element={<AccessDenied/>}/>
          : permissionPending ?
            <Route path='/*' element={null}/>
          :
            <Route path='/*' element={<AuthorizedRouter/>}/>
          }
          {/* //   :
          //   <Route path='/*' element={<NoAuthorizedRouter/>}/>
          // } */}
        </Routes>
      </RouterWrapper>
  )
}

export default RootRouter
